import {useTranslation} from "react-i18next";

export default function EventListLocation({location}) {
    const { t } = useTranslation();

    const [main, ...other] = location.filter(Boolean);
    const displayOther = other.length ? <>, <span>{ t('conferences.conference.and') }{other.length}</span></> : null;

    return main ? <li className="city">{main}{displayOther}</li> : null;
}
